import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon, obj = logged in
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        setError(null);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data);
            return data;
        } catch (e) {
            const msg = formatApiError(e);
            setError(msg);
            throw new Error(msg);
        }
    };

    const register = async (payload) => {
        setError(null);
        try {
            const { data } = await api.post("/auth/register", payload);
            // Professional registrations return pending_approval=true and no cookies are set.
            if (!data.pending_approval) {
                setUser(data);
            }
            return data;
        } catch (e) {
            const msg = formatApiError(e);
            setError(msg);
            throw new Error(msg);
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); }
        catch (e) { console.warn("Logout request failed (proceeding with client-side clear)", e); }
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, error, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
